import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import "../styles/App.css";

import About from "../pages/About";
import Education from "../pages/Education";
import Internships from "../pages/Internships";
import Projects from "../pages/Projects";
import Extracurriculars from "../pages/Extracurriculars";
import ScrollToTop from "../components/ScrollToTop";
import { FaMapMarkerAlt, FaUniversity, FaEnvelope, FaGithub, FaLinkedin, FaBlog, FaTwitter } from 'react-icons/fa';
import ProfileImg from '../images/profile_me.jpeg';

function AppLayout() {
  const location = useLocation();

  // 🌊 Water Ripple Cursor Logic
  useEffect(() => {
    const cursor = document.getElementById("ripple-cursor");
    if (!cursor) return;

    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    cursor.appendChild(dot);

    let lastRippleTime = 0;

    const createRipple = (x, y) => {
      const now = Date.now();
      if (now - lastRippleTime < 80) return;
      lastRippleTime = now;

      const ripple = document.createElement("div");
      ripple.className = "ripple";
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;

      cursor.appendChild(ripple);

      setTimeout(() => ripple.remove(), 1200);
    };

    const moveCursor = (e) => {
      const x = e.clientX;
      const y = e.clientY;

      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;

      createRipple(x, y);
    };

    if (!("ontouchstart" in window)) {
      window.addEventListener("mousemove", moveCursor);
    }

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      cursor.innerHTML = "";
    };
  }, []);

  return (
    <div className='pages'>
      {/* 🌊 Ripple Cursor Container */}
      <div id="ripple-cursor"></div>

      <nav className="academic-nav">
        <div className="nav-container">
          <div className="nav-left"><strong>{location.pathname === '/' ? 'About' : location.pathname.substring(1).charAt(0).toUpperCase() + location.pathname.substring(2)}</strong> | Harshita Singh</div>
          <div className="nav-right">
            <Link to="/">About</Link>
            <Link to="/education">Education</Link>
            <Link to="/internships">Internships</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/extracurriculars">Extracurriculars</Link>
          </div>
        </div>
      </nav>

      <div className="academic-container">
        <aside className="sidebar">
          <img src={ProfileImg} alt="Harshita Singh" className="profile-img" />
          <h2>Harshita Singh</h2>
          <p className="subtitle">Software Engineer | AI/ML | UI/UX</p>
          <ul className="social-links">
            <li><FaMapMarkerAlt /> Gurgaon, India</li>
            <li><FaUniversity /> Vellore Institute of Technology, AP</li>
            <li><FaEnvelope /> <a href="mailto:sharshitaa3@gmail.com">sharshitaa3@gmail.com</a></li>
            <li><FaGithub /> <a href="https://github.com/manno198" target="_blank" rel="noreferrer">Github</a></li>
            <li><FaLinkedin /> <a href="https://www.linkedin.com/in/harshita-singh-ba0771274/" target="_blank" rel="noreferrer">LinkedIn</a></li>
            <li><FaTwitter /> <a href="https://x.com/HarshitaS1425" target="_blank" rel="noreferrer">X</a></li>
            <li><FaBlog /> <a href="https://www.blogger.com/profile/18003405951123675118" target="_blank" rel="noreferrer">Blog</a></li>
          </ul>
        </aside>

        <main className="content">
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/education" element={<Education />} />
            <Route path="/internships" element={<Internships />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/extracurriculars" element={<Extracurriculars />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <AppLayout />
      </Router>
    </div>
  );
}

export default App;
